export class SmartBar {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "SmartBar";
    this.scene = "SmartBar";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    this.data.push({
      name: "Title",
      value: {
        text: options.name || "",
      },
    });

    this.data.push({
      name: "Position",
      value: {
        text: options.player?.squad?.position || "",
      },
    });
    this.data.push({
      name: "First Name",
      value: {
        text: options.player?.first_name || "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player?.last_name || "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text: options.player?.first_name_upper || "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text: options.player?.last_name_upper || "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player?.first_name || "") +
          " " +
          (options.player?.last_name || ""),
      },
    });

    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player?.first_name_upper || "") +
          " " +
          (options.player?.last_name_upper || ""),
      },
    });

    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player?.first_name || "") +
          " " +
          (options.player?.last_name || ""),
      },
    });

    this.data.push({
      name: "Image",
      value: {
        image: "${user}" + (options.image || ""),
      },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: options.subline,
      },
    });
    this.data.push({
      name: "Team Type",
      value: {
        text:
          options.team?._id === options.game?.home_team?._id
            ? "home"
            : options.team?._id === options.game?.away_team?._id
            ? "away"
            : "",
      },
    });

    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Team Third Badge",
      value: {
        image: "${user}" + options.team?.variables?.third_badge || "",
      },
    });
    let kit =
      options.team?._id === options.game?.home_team?._id
        ? options.game?.home_team_kit
        : options.game?.away_team_kit;

    this.data.push({
      name: "Team Kit BG Colour",
      value: {
        colour: options.kit || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });

    this.data.push({
      name: "Team Kit BG Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });
    this.data.push({
      name: "Bar Content",
      value: {
        text: options.rightcontent,
      },
    });
    this.data.push({
      name: "Bar Option",
      value: {
        text: options.baroption,
      },
    });
    this.data.push({
      name: "Bar OMO",
      value: {
        text: options.baromo,
      },
    });
    this.data.push({
      name: "Badge OMO",
      value: {
        text: options.badgeomo,
      },
    });
    this.data.push({
      name: "Image OMO",
      value: {
        text: options.imageomo,
      },
    });
    this.data.push({
      name: "Content Type",
      value: {
        text: options.contenttype,
      },
    });
    this.data.push({
      name: "Stat 1 Title",
      value: {
        text: options.stat1title,
      },
    });
    this.data.push({
      name: "Stat 1 Content",
      value: {
        text: options.stat1content,
      },
    });
    this.data.push({
      name: "Stat 2 Title",
      value: {
        text: options.stat2title,
      },
    });
    this.data.push({
      name: "Stat 2 Content",
      value: {
        text: options.stat2content,
      },
    });
    this.data.push({
      name: "Stat 3 Title",
      value: {
        text: options.stat3title,
      },
    });
    this.data.push({
      name: "Stat 3 Content",
      value: {
        text: options.stat3content,
      },
    });
    this.data.push({
      name: "Stat 4 Title",
      value: {
        text: options.stat4title,
      },
    });
    this.data.push({
      name: "Stat 4 Content",
      value: {
        text: options.stat4content,
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
